import { IosShare } from "@mui/icons-material";
import { useMemo, useState } from "react";
import { Alert, Box, Button, Snackbar } from "@mui/material";
import { ShareAlert } from "../../models/ShareAlert";

export const ShareSearchResult = () => {
  const [alert, setAlert] = useState<ShareAlert>();

  const path = useMemo(() => {
    const baseURL = "https://eltrp.org";
    return baseURL + window.location.pathname + window.location.search;
  }, []);

  const shareResult = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(path)
        .then(() =>
          setAlert({
            open: true,
            message:
              "Copied link to search result to clipboard. Share the link with others!",
            severity: "success",
          }),
        )
        .catch(() =>
          setAlert({
            open: true,
            message: `Error trying to copy content. Please copy page url manually.`,
            severity: "error",
          }),
        );
    } else if (!navigator.clipboard) {
      setAlert({
        open: true,
        message: `Error trying to copy content. Please copy page url manually.`,
        severity: "error",
      });
    }
  };
  return (
    <Box mt={-1}>
      <Button
        startIcon={<IosShare />}
        onClick={shareResult}
        variant={"contained"}
        color={"secondary"}
      >
        Share search result
      </Button>
      {alert && (
        <Snackbar
          autoHideDuration={alert.severity === "success" ? 6000 : undefined}
          open={alert?.open}
          onClose={() => setAlert(undefined)}
        >
          <Alert severity={alert.severity}>{alert?.message}</Alert>
        </Snackbar>
      )}
    </Box>
  );
};